import axios from 'axios';

// Definimos la URL base. Intenta usar la variable de entorno, si no, usa localhost.
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000, // Evita cuelgues infinitos (15s)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor: Añade el token a cada petición si existe
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor: Si el servidor dice "No autorizado" (401), cerramos sesión a la fuerza
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Limpiamos localStorage directamente aquí para evitar llamar a authService y crear el círculo
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;